// TODO: confirmar valores de Transaccion / Accion / Programa con equipo de negocio/backend

interface AuditoriaPayload {
  transaccion: string;
  programa: string;
  tipoIdUsuario: unknown;
  numIdUsuario: unknown;
  nombreUsuario: string | undefined;
  tipoIdAfiliado: unknown;
  numIdAfiliado: unknown;
  ipUsuario: string;
  datosAdicionales: Record<string, unknown>;
}

const AUDIT_URL = '/_vti_bin/Servicios/ServicioTransar.svc/RegistrarAuditoriaED';

export const useAuditoria = () => {
  const registrarAuditoria = (payload: AuditoriaPayload): void => {
    const {
      transaccion,
      programa,
      tipoIdUsuario,
      numIdUsuario,
      nombreUsuario,
      tipoIdAfiliado,
      numIdAfiliado,
      ipUsuario,
      datosAdicionales,
    } = payload;

    const ciudad =
      (typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('CiudadUsuario') : null) || 'N/A';

    const body = JSON.stringify({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      __type: 'AuditoriaRequest:#Consorcio.Transar.Entities.Services.Auditoria',
      TipoIdentificacionUsuario: tipoIdUsuario,
      NumeroIdentificacionUsuario: numIdUsuario,
      NombreUsuario: nombreUsuario,
      ProgramaAfiliacion: programa,
      Transaccion: transaccion,
      TipoIdenficacionAfiliado: tipoIdAfiliado,
      NumeroIdentificacionAfiliado: numIdAfiliado,
      IPUsuario: ipUsuario,
      DatosAdicionales: JSON.stringify({
        // Orden idéntico al esquema de referencia (PCGenerarCertificado)
        Accion: datosAdicionales['Accion'],
        NumeroRadicado: 'N/A',
        Adjuntos: 'N/A',
        EmpresaCreada: 'N/A',
        ClienteCreado: 'N/A',
        ClienteVinculado: 'N/A',
        CiudadUsuario: ciudad,
        Rol: (datosAdicionales['Rol'] as string) ?? 'N/A',
        Sede: (datosAdicionales['Sede'] as string) ?? 'Sede no asociada',
        CorreoElectronico: datosAdicionales['CorreoElectronico'] ?? 'N/A',
        Resultado: datosAdicionales['Resultado'],
        MensajeError: datosAdicionales['MensajeError'] ?? '',
      }),
    });

    fetch(`${document.location.origin}${AUDIT_URL}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
    }).catch(() => {
      // Fire-and-forget: el error de auditoría no bloquea el flujo principal
    });
  };

  return { registrarAuditoria };
};
